import { FC } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { BatteryStatusSummary } from './BatteryStatusSummary';
import { BatteryRow } from './BatteryRow';
import { ShoppingCart, Plus } from 'lucide-react';
import type { Battery } from '@/hooks/useBatteryContainers';

interface ToOrderSectionProps {
  batteries: Battery[];
  allocations?: Map<string, string>;
  onAddToOrder?: () => void;
  onAllocate?: (battery: Battery) => void;
  onEdit?: (battery: Battery) => void;
  onDelete?: (battery: Battery) => void;
}

export const ToOrderSection: FC<ToOrderSectionProps> = ({
  batteries,
  allocations,
  onAddToOrder,
  onAllocate,
  onEdit,
  onDelete,
}) => {
  const toOrderBatteries = batteries.filter(b => b.status === 'te_bestellen');
  const powerLevels = [50, 100];

  return (
    <Card className="h-full flex flex-col border-l-4 border-l-yellow-500">
      <CardHeader className="pb-3 flex-row items-center justify-between space-y-0">
        <CardTitle className="flex items-center gap-2 text-yellow-700 dark:text-yellow-400">
          <ShoppingCart className="h-5 w-5" />
          Te bestellen
        </CardTitle>
        {onAddToOrder && (
          <Button size="sm" variant="outline" onClick={onAddToOrder}>
            <Plus className="h-4 w-4 mr-1" />
            Batterij
          </Button>
        )}
      </CardHeader>
      <CardContent className="flex-1 overflow-auto space-y-4">
        {toOrderBatteries.length > 0 ? (
          <div className="space-y-4">
            {powerLevels.map((powerKw) => (
              <BatteryRow
                key={powerKw}
                batteries={toOrderBatteries}
                powerKw={powerKw}
                allocations={allocations}
                onAllocate={onAllocate}
                onEdit={onEdit}
                onDelete={onDelete}
              />
            ))}
          </div>
        ) : (
          <div className="text-center py-8">
            <ShoppingCart className="h-12 w-12 text-muted-foreground/50 mx-auto mb-2" />
            <p className="text-sm text-muted-foreground mb-4">
              Geen batterijen te bestellen
            </p>
            {onAddToOrder && (
              <Button size="sm" onClick={onAddToOrder}>
                <Plus className="h-4 w-4 mr-2" />
                Batterij toevoegen
              </Button>
            )}
          </div>
        )}
        
        <BatteryStatusSummary batteries={toOrderBatteries} allocations={allocations} />
      </CardContent>
    </Card>
  );
};
